import React from "react";
import numeral from "numeral";
import styled, { css } from "styled-components";
import { Trans, useTranslation } from "react-i18next";
import HideOnCloud from "util/conditional/HideOnCloud";
import { Alert } from "components/bootstrap";
import { IndexerClusterHealthSummary } from "components/indexers";
export const StyledAlert = styled(Alert)(
  ({ theme }) => css`
    margin-top: ${theme.spacings.md};
  `
);
const ArchiveIndicesInfo = ({ indexSetOverview }) => {
  var _a;
  const { t } = useTranslation("enterprise_archive");
  if (!indexSetOverview) return null;
  const indicesCount = indexSetOverview.indices.length;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledAlert, { bsStyle: "success" }, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "archive_indices_info.summary",
      values: {
        number: indicesCount,
        messages: numeral(indexSetOverview.counts.events).format("0,0"),
        index: (_a = indexSetOverview.deflector.current_target) != null ? _a : t("archive_indices_info.none")
      },
      components: { i: /* @__PURE__ */ React.createElement("i", null) }
    }
  )), /* @__PURE__ */ React.createElement(HideOnCloud, null, /* @__PURE__ */ React.createElement(IndexerClusterHealthSummary, { health: indexSetOverview.indexer_cluster.health })));
};
export default ArchiveIndicesInfo;
